export const routes = {
    home: '/'
}